module.exports = __webpack_public_path__ + "static/media/veterano_d.74d64bc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/veterano_d.png
// module id = 1154
// module chunks = 0